import { lazy } from "react";

/**
 * Lazy-loaded components for different forms used in the application.
 */
export const InstructorLoginForm = lazy(() => import("./Login/index.form"));
export const InstructorSignupForm = lazy(() => import("./Signup/index.form"));
